const notFoundImage = require('../assets/olive-and-hardy-empty-pockets.jpg');

let error404 = {
  render: async () => {
    let view = /*html*/ `
      <div id="container" class="container">
        <div class="row text-center">
          <div class="col"><h1>404 page not found</h1></div>
        </div>
        <div class="row text-center">
          <div class="col"><img id="404img" src="https://img.posterlounge.co.uk/img/products/370000/363937/363937_poster_l.jpg"/></div>
        </div>
      </div>
      `;
    return view;
  },
  after_render: async () => {
    //document.getElementById('404img').src = notFoundImage;
    Array.from(document.getElementsByClassName('loader')).forEach(x => x.style.display = 'none');
  },
};
export default error404;
